export default __webpack_public_path__ + "static/media/emmanuel.747d4612.jpg";